module.exports = __webpack_public_path__ + "static/media/armadillo-logo.257ffc26.png";